import React, { useState } from "react";
import styles from "../styles/Contact.module.css";
import api from "../services/api"; 

const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // ✅ use your API handler
      await api.post("/contacts", form);
      setSubmitted(true);
    } catch (err) {
      console.error("Failed to send contact form:", err);
      alert("There was an error sending your message. Please try again.");
    }
  };

  return (
    <div className={styles.contact}>
      <section className={styles.contactContainer}>
        <div className={styles.formSection}>
          {submitted ? (
            <div className={styles.successMessage}>
              <h3>✅ Thank you!</h3>
              <p>Your message has been sent successfully.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />

              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="you@example.com"
              />

              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                placeholder="Type your message here..."
              />

              <button type="submit">Send Message</button>
            </form>
          )}
        </div>

        <div className={styles.infoSection}>
          <h3>Our Office</h3>
          <p>
            <strong>Location:</strong> Plot 12 Buganda road Bhatia house
          </p>
          <p>
            <strong>Phone:</strong> +256 707 442 784
          </p>
          <p>
            <strong>Email:</strong> info@greystarmotors.com
          </p>

          <div className={styles.mapContainer}>
            <iframe
              title="GraystarMotors Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.867902641726!2d32.57999367565294!3d0.3151454996862222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbbfb2c87d9b9%3A0xb8dfe4b83c08f3fa!2sBhatia%20House%2C%20Plot%2012%20Buganda%20Rd%2C%20Kampala!5e0!3m2!1sen!2sug!4v1730790500000!5m2!1sen!2sug"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
